import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-subtitles',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './subtitles.component.html',
  styleUrl: './subtitles.component.scss'
})
export class SubtitlesComponent {
  public text = '';

  render(data: string) {
    this.text = data;
  }
}
